import { types, flow, applySnapshot } from 'mobx-state-tree';
import { pick } from 'lodash';
import { makeRequest } from 'js/services/Network';
import ItemListing from '../types/ItemListing';

export default types
  .model('MyItemsPage', {
    first_name: '',
    items: types.optional(types.array(ItemListing), []),
    micro_store: '',
    page: 1,
    last_page: 0,
    count: 5,
    storeValue: 0,
    is_loading: false,
  })
  .views(self => ({
    get hasMorePages() {
      return self.page < self.last_page;
    },
  }))
  .actions(self => ({
    load: flow(function* load(refresh = false) {
      let response;
      if (!self.is_loading) {
        refresh && applySnapshot(self, {});
        self.is_loading = true;
        try {
          response = yield makeRequest('my-items-data', null, pick(self, ['page', 'count']));
          self.first_name = response.data.first_name || '';
          self.storeValue = response.data.store_value;
          self.last_page = response.data.items.last_page;
          self.micro_store = response.data.micro_store;
          response.data.items.data.forEach(item => self.items.push(item));
          self.is_loading = false;
        } catch (error) {
          self.is_loading = false;
          throw error;
        }
      }
      return response;
    }),
    loadMore() {
      if (self.page < self.last_page) {
        self.page++;
        self.load();
      }
    },
  }));
